import { render, staticRenderFns } from "./CoursewarePlayVideoChapter.vue?vue&type=template&id=dc4568c4&"
import script from "./CoursewarePlayVideoChapter.vue?vue&type=script&lang=js&"
export * from "./CoursewarePlayVideoChapter.vue?vue&type=script&lang=js&"
import style0 from "./CoursewarePlayVideoChapter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CoursewarePlayVideoChapter.vue"
export default component.exports